import { useCallback, useState } from "react";

// Liste filtrelerini sessionStorage'da saklamak için ortak mekanizma.
// Listeden detaya gidip geri dönünce (browser geri tuşu dahil) liste aynı
// filtre/sayfa/aramayla açılır. sessionStorage sekmeye özel olduğu için
// sekme kapanınca temizlenir; kalıcı tercih kirliliği oluşmaz.

export const readPersistedFilters = (storageKey) => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const writePersistedFilters = (storageKey, value) => {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(value));
  } catch (_) {
    // storage dolu/kapalıysa sessizce geç — filtre kalıcılığı best-effort
  }
};

// Obje tabanlı filtre state'i: useState gibi kullanılır, her güncelleme
// sessionStorage'a da yazılır. Öncelik sırası: `override` (ör. başka
// sayfadan location.state ile gelen deep-link araması) > storage > defaults.
export default function usePersistedFilters(
  storageKey,
  defaults,
  override = null,
) {
  const [value, setValue] = useState(() => {
    const initial = {
      ...defaults,
      ...(readPersistedFilters(storageKey) || {}),
      ...(override || {}),
    };
    // Override (deep-link) storage'a da yazılır — detaya gidip dönünce
    // deep-link'le gelen arama kaybolmasın (yazma idempotent, StrictMode
    // çift çağrısı sorun değil).
    if (override) writePersistedFilters(storageKey, initial);
    return initial;
  });

  const update = useCallback(
    (updater) => {
      setValue((prev) => {
        const next = typeof updater === "function" ? updater(prev) : updater;
        writePersistedFilters(storageKey, next);
        return next;
      });
    },
    [storageKey],
  );

  return [value, update];
}
